export default __webpack_public_path__ + "static/media/ribbon.93ea935f.gif";